import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { PageHeader } from '../components/ui/PageHeader';
import { sceneImages } from '../data/images';
const applications = [{
  title: 'Swimming pools',
  body: 'Wash walls and floors in electric blue or any of the advertised colors. Start with 8–24 lights depending on size.',
  image: sceneImages.mediumPool,
  to: '/systems',
  cta: 'Complete Lighting Systems'
}, {
  title: 'Spas & hot tubs',
  body: 'A compact 4-Light System creates an intimate, evenly lit spa after dark.',
  image: sceneImages.spa,
  to: '/systems',
  cta: '4-Light System'
}, {
  title: 'Steps, entries & corners',
  body: 'Add individual lights to define edges and transitions — or add them alongside a complete system.',
  image: sceneImages.poolSteps,
  to: '/build',
  cta: 'Build Your Own'
}, {
  title: 'Water features & accents',
  body: 'Fountains, ponds and architectural water. Choose any quantity, starting at one light.',
  image: sceneImages.waterTexture,
  to: '/build',
  cta: 'Build Your Own'
}];
export function Applications() {
  return <>
      <PageHeader image={sceneImages.heroPool} title={<>
            Transform Your Water <span className="text-ice" data-id="element-946" data-mp="3so4u7urq6sdw">After Dark.</span>
          </>} lead="Wherever there's water, the M1 PRO brings professional-grade light — without wiring the space." data-id="element-945" data-mp="1giqk250apx1" />
      <div className="mx-auto max-w-site px-5 py-20 md:px-8 md:py-28" data-id="element-947" data-mp="3ixa2wbzmh2ll">
        <div className="space-y-20 md:space-y-28" data-id="element-948" data-mp="3dyfdgr75gfsi">
          {applications.map((a, i) => <article key={a.title} className="grid items-center gap-10 md:grid-cols-2 md:gap-16" data-id="element-949" data-mp="39wu43fttqjn2" data-mpi={i}>
              <img src={a.image} alt="" className={`aspect-[4/3] w-full rounded-2xl object-cover ${i % 2 ? 'md:order-2' : ''}`} data-id="element-950" data-mp="34xr8elzqhprr" />
              <div data-id="element-951" data-mp="3010iz821hhto">
                <h2 className="font-display text-4xl font-semibold uppercase leading-[0.95] md:text-5xl" data-id="element-952" data-mp="2qbbpjh4n07ee">{a.title}</h2>
                <p className="mt-5 max-w-md text-lg text-titanium" data-id="element-953" data-mp="2vaevd3sfyhnf">{a.body}</p>
                <Link to={a.to} className="mt-6 inline-flex items-center gap-2 font-display text-base font-semibold uppercase tracking-[0.12em] text-ice hover:text-white" data-id="element-954" data-mp="2gd4ch9dgy9ho">
                  {a.cta} <ArrowRightIcon className="h-4 w-4" data-id="element-955" data-mp="392utbq6hjphh" />
                </Link>
              </div>
            </article>)}
        </div>
        <p className="mt-20 text-sm text-titanium/70" data-id="element-956" data-mp="3e2h4zv6o0xo6">
          For salt water, high-chlorine or extreme-temperature environments, contact our team before installing. Always
          follow the recommended mounting method.
        </p>
      </div>
    </>;
}